export default __webpack_public_path__ + "static/media/pocketcast.24413dae.svg";